import { useNavigate } from "react-router-dom";
import { useAuthStore } from "@/stores/authStore";
import { useUiStore } from "@/stores/uiStore";
import { logout } from "@/api/auth";
import { GlobalSearchBar } from "./GlobalSearchBar";
import { CasePicker } from "./CasePicker";
import { Button } from "@/components/ui/Button";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "@/components/ui/DropdownMenu";
import { Plus, User, LogOut, Moon, Sun, Monitor } from "lucide-react";

export function TopBar() {
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);
  const refreshToken = useAuthStore((s) => s.refreshToken);
  const clear = useAuthStore((s) => s.clear);
  const darkMode = useUiStore((s) => s.darkMode);
  const setDarkMode = useUiStore((s) => s.setDarkMode);

  async function handleLogout(global = false) {
    if (refreshToken) {
      try {
        await logout({ refreshToken, global });
      } catch {
        // ignore
      }
    }
    clear();
    navigate("/login");
  }

  return (
    <header className="flex h-14 items-center gap-4 border-b border-border bg-surface px-4">
      <GlobalSearchBar />
      <CasePicker />

      <div className="ml-auto flex items-center gap-2">
        <Button size="sm" onClick={() => navigate("/types")}>
          <Plus className="h-4 w-4" />
          New Entity
        </Button>

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="icon">
              <User className="h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <div className="px-2 py-1.5 text-sm font-medium">
              {user?.displayName ?? user?.username}
            </div>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={() => setDarkMode("light")}>
              <Sun className="mr-2 h-4 w-4" />
              Light
              {darkMode === "light" && <span className="ml-auto text-xs">*</span>}
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => setDarkMode("dark")}>
              <Moon className="mr-2 h-4 w-4" />
              Dark
              {darkMode === "dark" && <span className="ml-auto text-xs">*</span>}
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => setDarkMode("system")}>
              <Monitor className="mr-2 h-4 w-4" />
              System
              {darkMode === "system" && <span className="ml-auto text-xs">*</span>}
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={() => handleLogout(false)}>
              <LogOut className="mr-2 h-4 w-4" />
              Sign out
            </DropdownMenuItem>
            <DropdownMenuItem danger onClick={() => handleLogout(true)}>
              <LogOut className="mr-2 h-4 w-4" />
              Sign out everywhere
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
}
